
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {TokenInfo} from './TokenInfo';
import {FieldModelTokenInfo} from './TokenInfo';

/**
 * TokensGetResult struct
 */
class TokensGetResult {
  /**
   * Initialize struct
   * @param {!Array=} tokens
   * @constructor
   */
  constructor (tokens = []) {
    this.Tokens = tokens
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TokensGetResult}
   * @param {!TokensGetResult} other Other struct
   * @returns {!TokensGetResult} This struct
   */
  copy (other) {
    if (other.Tokens != null) {
      this.Tokens = []
      for (let item of other.Tokens) {
        if (item != null) {
          let tempItem
          tempItem = TokenInfo.fromObject(item)
          this.Tokens.push(tempItem)
        } else {
          this.Tokens.push(null)
        }
      }
    } else {
      this.Tokens = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TokensGetResult}
   * @returns {!TokensGetResult} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TokensGetResultModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TokensGetResultModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TokensGetResult}
   * @param {!TokensGetResult} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TokensGetResult)) {
      throw new TypeError('Instance of TokensGetResult is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TokensGetResult}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Tokens: ((this.Tokens != null) ? Array.from(this.Tokens, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TokensGetResult.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TokensGetResult} other Object value
   * @returns {!TokensGetResult} Created struct
   */
  static fromObject (other) {
    return new TokensGetResult().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TokensGetResult}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TokensGetResult.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TokensGetResult}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 14118
  }
}

export { TokensGetResult };

/**
 * Fast Binary Encoding TokensGetResult field model
 */
class FieldModelTokensGetResult extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Tokens = new fbe.FieldModelVector(new FieldModelTokenInfo(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Tokens.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Tokens.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTokensGetResult.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 14118
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTokensGetResult}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTokensGetResult}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Tokens.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Tokens.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Tokens.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTokensGetResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTokensGetResult}
   * @param {!TokensGetResult} fbeValue Default value, defaults is new TokensGetResult()
   * @returns {!TokensGetResult} TokensGetResult value
   */
  get (fbeValue = new TokensGetResult()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTokensGetResult}
   * @param {!TokensGetResult} fbeValue TokensGetResult value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Tokens.fbeSize) <= fbeStructSize) {
      this.Tokens.get(fbeValue.Tokens)
    } else {
      fbeValue.Tokens.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Tokens.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTokensGetResult}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTokensGetResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTokensGetResult}
   * @param {!TokensGetResult} fbeValue TokensGetResult value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTokensGetResult}
   * @param {TokensGetResult} fbeValue TokensGetResult value
   */
  setFields (fbeValue) {
    this.Tokens.set(fbeValue.Tokens)
  }
}

export { FieldModelTokensGetResult };

/**
 * Fast Binary Encoding TokensGetResult model
 */
class TokensGetResultModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTokensGetResult(this.buffer, 4)
  }

  /**
   * Get the TokensGetResult model
   * @this {!TokensGetResultModel}
   * @returns {!FieldModelTokensGetResult} model TokensGetResult model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TokensGetResultModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TokensGetResultModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TokensGetResultModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TokensGetResultModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTokensGetResult.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TokensGetResultModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TokensGetResultModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TokensGetResultModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TokensGetResultModel}
   * @param {!TokensGetResult} value TokensGetResult value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TokensGetResultModel}
   * @param {!TokensGetResult} value TokensGetResult value, defaults is new TokensGetResult()
   * @return {!object} Deserialized TokensGetResult value and its size
   */
  deserialize (value = new TokensGetResult()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TokensGetResult(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TokensGetResult(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TokensGetResultModel}
   * @param {!number} prev Previous TokensGetResult model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TokensGetResultModel };
